import { nanoid } from 'nanoid'
import React, { ChangeEvent, FC, SelectHTMLAttributes, useState } from 'react'
import Label from '@app/components/Label'
import { Icon } from '@iconify/react'
import S from './SelectField.styles'
import FieldError from '../FieldError/FieldError'

interface Option {
  value: string
  label: string
}

interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  options: Option[]
  placeholder?: string
  /** Optional error component to render */
  error?: string
}

const SelectField: FC<SelectFieldProps> = ({
  label,
  name = nanoid(),
  placeholder,
  options,
  error,
  onChange,
  onBlur,
}) => {
  const [value, setValue] = useState('')

  const select = (ev: ChangeEvent<HTMLSelectElement>) => {
    setValue(ev.currentTarget.value)
    onChange?.(ev)
  }

  return (
    <S.SelectField>
      {label && <Label htmlFor={name}>{label}</Label>}
      <S.Wrapper>
        <S.Select id={name} name={name} value={value} onChange={select} onBlur={onBlur}>
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map(o => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </S.Select>
        <Icon icon="bx:chevron-down" fontSize={20} />
      </S.Wrapper>
      <FieldError show={!!error} message={error} />
    </S.SelectField>
  )
}

export default SelectField
